import React from "react";
import Logo from "../Img/logo.png";
import Axios from 'axios'
import API from '../Utils/api'
import { getUsuarioFromStorage } from "../Utils/usuarioHelper";
import moment from 'moment';
import GerenteTemplate from "./GerenteTemplate";
import { element } from "prop-types";
import { Link } from 'react-router-dom';

export class CaixaGerente extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      pedidos: [],
      saidas: 0,
      entradas: 0,
      comissao: 0,
      totalBruto: 0,
      comissaoCambistas: 0,
      transacoes: [],
      lancamentoValor: 0,
      cambistas: null,
      documento: "",
      observacao: "",
      allTransacoesId: [],
      allPedidosId: []
    };
    this.listarTransacoes();
    this.getPedidosPorGerente()

  }


  async getPedidosPorGerente() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("pedidos/listar-pedidos", {
        id: this.state.user._id
      });
      var totCartelas = 0;
      response.data.map(pedidos => {
        totCartelas += pedidos.cartelas.length;
      })
      this.setState({ pedidos: response.data, comissao: this.state.user.comissao * totCartelas })
    } catch (err) {
      console.log(err);
    }
  };



  // getCaixaGerente = async (e) => {
  //   try {
  //     var axiosInstance = new Axios.create({
  //       baseURL: window.localStorage.getItem("apiUrl")
  //     });
  //     const response = await axiosInstance.post("transacoes/caixa-gerente", {
  //       userId: this.state.user._id
  //     });
  //     this.setState({ transacoes: response.data })

  //     this.gerarSaldos()
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };


  formatDate(data) {
    return moment(data).add(0, 'days').format('DD-MM-YYYY')
  }
  getUser = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/user", {
        id: this.state.user._id
      });

      window.localStorage.setItem("user", JSON.stringify(response.data[0]));
      this.setState({ user: response.data[0] });
    } catch (err) {
      console.log(err);
    }
  };



  listarTransacoes = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("transacoes/caixa-gerente", {
        userId: this.state.user._id
      });
      this.setState({ transacoes: response.data });
      console.log(response.data)
      this.gerarSaldos();
    } catch (err) {
      console.log(err);
    }
  };

  gerarSaldos() {
    var comissaoCambistas = 0;
    var totalBruto = 0;
    this.state.transacoes.map(item => {
      comissaoCambistas += item.taxaComissao;
      totalBruto += item.valor;
    })
    this.setState({
      comissaoCambistas: comissaoCambistas,
      totalBruto: totalBruto,
      entradas: totalBruto - comissaoCambistas
    });
  }





  render() {
    return (
      <GerenteTemplate label="Caixa">

        <div class="content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="card strpied-tabled-with-hover">
                  <div class="card-header ">
                    <div class="row">
                      <div class="col">
                        <h4 class="card-title">Caixa da rodada</h4>
                        <p class="card-category">Informações do caixa.</p>
                      </div>
                    </div>
                  </div>
                  <div class="card-body table-full-width table-responsive">
                    <div class="container">
                      <div class="row">
                        <div class="col font-weight-bold text-dark">
                          Faturamento total:  R${(this.state.totalBruto).toFixed(2)}
                        </div>
                        <div class="col font-weight-bold text-success">
                          Faturamento sem TAXAS: R${(this.state.entradas).toFixed(2)}
                        </div>
                        <div class="col font-weight-bold text-dark">
                          Total em Taxas de venda: R${(this.state.comissaoCambistas).toFixed(2)}
                        </div>
                        <div class="col font-weight-bold text-dark">
                          Sua comissão: R${this.state.comissao.toFixed(2)}
                        </div>
                        <div class="col font-weight-bold text-warning">
                          Valor a ser prestado: R${((this.state.entradas - this.state.saidas) - this.state.comissao).toFixed(2)}
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="card strpied-tabled-with-hover">
                  <div class="card-header ">
                    <h4 class="card-title">Acompanhe suas movimentações</h4>
                    <p class="card-category">Informações de movimentações.</p>
                  </div>
                  <div class="card-body table-full-width table-responsive">
                    <table class="table table-hover table-striped">
                      <thead>
                        <tr>
                          <th>Data</th>
                          <th>Tipo</th>
                          <th>Emissor</th>
                          <th>Receptor</th>
                          <th>Valor</th>
                          <th>Taxa de venda</th>
                          <th>Documento</th>
                          <th>Observação</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.transacoes?.map((item) => {
                          return (

                            <tr
                              class=
                              "font-weight-bold "

                            >
                              <td >{this.formatDate(item.data)}</td>
                              <td >{item.tipo}</td>
                              {/* <td >{item.emissorId._id == this.state.user._id? 'SAIDA' :  'ENTRADA'}</td> */}
                              <td >{item.emissorId ? item.emissorId.nome : "Desconhecido"}</td>
                              <td >{item.receptorId ? item.receptorId.nome : "Desconhecido"}</td>
                              <td >
                                {item.emissorId ? ((item.emissorId._id == this.state.user._id
                                  ? "-"
                                  : "+") + item.valor) : ""}
                              </td>
                              <td >{item.taxaComissao ? parseFloat(item.taxaComissao).toFixed(2) : "0"}</td>
                              <td  >{item.documento}</td>
                              <td >{item.observacao}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </GerenteTemplate>
    );
  }
}

export default CaixaGerente;
